export const getSpinnerId = (number: number, name: string, key?: string) => {
  const getId = (index: number) => {
    return key ? `${name}${key}${index}` : `${name}${index}`;
  };
  return Array.from({ length: number }).map((_, index) => {
    return {
      id: getId(index),
      begin: index === 0 ? `0s;${getId(number - 1)}.end` : `${getId(index - 1)}.end`,
    };
  });
};
